export enum AssignToRouteFormFields {
  ExistingOrNew = 'existingOrNew',
  ExistingRoute = 'existingRoute',
  RouteCategoryCd = 'routeCategoryCd',
  NewRouteArea = 'newRouteArea',
  NewRouteSuffix = 'newRouteSuffix',
}
